import React from 'react';
import { StyledToast } from './Toast.styles';
export const Toast = (props) => {
    const { className = '', style = {} } = props;
    return (React.createElement(StyledToast, { className: `Toast ${className} ${props.toast.style} ${props.toast.display ? 'show' : 'hide'}`, style: style || {} },
        React.createElement("span", { "data-cy": `toast--${props.toast.style}` }, props.toast.message)));
};
//# sourceMappingURL=Toast.js.map